/* eslint-disable prefer-destructuring */

import { Controller } from 'stimulus';

const places = require('places.js');

export default class extends Controller {
  static targets = [
    'field',
    'name',
    'near',
    'search',
    'searchTermType',
    'searchTermValue',
    'lat',
    'lang',
  ];

  connect() {
    this.params = {};
    if (typeof google != 'undefined') {
      this.initPlaces();
    }

    const that = this;
    document.addEventListener('autocomplete.change', function (e) {
      const { value, textValue } = e.detail;

      const searchTermType = value.split('_')['1'];

      console.log(searchTermType);
      document
        .getElementById('searchTerm')
        .setAttribute('name', searchTermType);
      that.searchTermTypeTarget.value = searchTermType;
      that.searchTermValueTarget.value = value;
    });

    if (document.getElementById('map_toggle')) {
      var map = document.getElementById('map_toggle');
      map.addEventListener('change', (event) => {
        document.getElementById('doctor_cards').classList.toggle('lg:w-8/12');
        document.getElementById('doctor_cards').classList.toggle('lg:w-full');
        document
          .getElementsByClassName('map-container')[0]
          .classList.toggle('lg:block');
      });
    }
  }

  initPlaces() {
    const options = {
      componentRestrictions: { country: ['us', 'pr', 'vi', 'gu', 'mp'] },
    };
    this.autocomplete = new google.maps.places.Autocomplete(
      this.fieldTarget,
      options
    );
    // this.autocomplete.bindTo('bounds', this.map)
    this.autocomplete.setFields([
      'address_components',
      'geometry',
      'icon',
      'name',
    ]);
    this.autocomplete.addListener(
      'place_changed',
      this.placeChanged.bind(this)
    );
  }

  placeChanged() {
    const place = this.autocomplete.getPlace();
    const name = place.name;
    const near = `${place.geometry.location.lat()},${place.geometry.location.lng()}`;

    const { value } = this.nameTarget;
    const paramHash = { near, place: name };

    // ⬅️ NEW: Re-run the initial autocomplete logic
    this.autoApplyInitialSearch();

    if (value !== undefined && value !== null && value !== '') {
      this.setParams();
    }
    this.params = paramHash;
  }

  submitSearch(event) {
    event.preventDefault();
    let url = '';
    this.setParams();

    const queryString = new URLSearchParams(this.params || {}).toString();
    if ('doctor_fdd_id' in this.params) {
      url = `/to-doctor-profile?doctor_fdd_id=${this.params.doctor_fdd_id}`;
    } else {
      url = `/search-map?${queryString}`;
    }
    Turbolinks.visit(url);
  }

  triggerAutocompleteSelection(value) {
    const event = new CustomEvent("autocomplete.change", {
      detail: { value }
    });
    document.dispatchEvent(event);
  }

  async autoApplyInitialSearch() {
    const term = this.nameTarget.value?.trim();
    if (!term) return;

    const url = this.autocompleteUrl = this.element.querySelector("[data-autocomplete-url-value]").dataset.autocompleteUrlValue;
    const response = await fetch(`${url}?q=${encodeURIComponent(term)}`);
    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, "text/html");
    const items = [...doc.querySelectorAll("li[role='option']")].map(li => ({
      label: li.textContent.trim(),
      value: li.dataset.autocompleteValue
    }));

    const match = items.find(item =>
      item.label.toLowerCase() === term.toLowerCase()
    );

    if (match) {
      this.triggerAutocompleteSelection(match.value);
    }
  }

  setParams() {
    const placeName = this.fieldTarget.value;
    if (placeName) this.params.place = placeName;
    const value = this.nameTarget.value;
    const searchTermType = this.searchTermTypeTarget.value;

    if (value !== undefined && value !== null && value !== '') {
      if (searchTermType == 'clinic') {
        this.params.clinic_name = value;
      } else if (searchTermType == 'doctor') {
        this.params.doctor_name = value;
        const doctorValueString = this.searchTermValueTarget.value;
        this.params.doctor_fdd_id = doctorValueString.split('_')['2'];
      } else if (searchTermType == 'treatment') {
        this.params.condition_slug = this.convertToSlug(value);
      } else if (searchTermType == 'procedure') {
        const procedureString = this.searchTermValueTarget.value;
        const procedure = procedureString.split('_')[0];
        this.params.procedure_slug = this.convertToSlug(procedure);
      } else if (searchTermType == 'condition') {
        const conditionString = this.searchTermValueTarget.value;
        const condition = conditionString.split('_')[0];
        this.params.condition_slug = this.convertToSlug(condition);
      } else if (searchTermType == 'specialtyGroup') {
        const specialityGroupValueString = this.searchTermValueTarget.value;
        this.params.specialty_group =
          specialityGroupValueString.split('_')['2'];
      } else {
        const specialityValueString = this.searchTermValueTarget.value;
        this.params.specialty = specialityValueString.split('_')['2'];
      }
      this.params.browser_search = true;
    }
  }

  convertToSlug(text) {
    // return text
    //   .toLowerCase()
    //   .replace(/ /g, '-')
    //   .replace(/[^\w-]+/g, '');
    if (["Nextera Healthcare", "ImagineMD"].includes(text)) {
      text = "KerixHealth";
    }
    return text
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-')   // replace ANY non-alphanumeric with hyphen
      .replace(/-+/g, '-')           // collapse multiple hyphens
      .replace(/^-|-$/g, '');        // remove leading/trailing hyphens
  }

  feedbackpopup() {
    document.querySelector('#feedbackpopup').classList.remove('hidden');
  }

  feedbackpopupclose() {
    var popups = document.querySelectorAll('.popup_container');
    for (var i = 0; i < popups.length; i++) {
      popups[i].classList.add('hidden');
    }
  }

  sadform() {
    document.getElementById('feedbackSubmit').disabled = true;
    document
      .getElementById('feedbackSubmit')
      .classList.remove('bg-doctor-yellow');
    document
      .getElementById('feedbackSubmit')
      .classList.add('bg-doctor-yellow-500');

    document.querySelector('#feedbackformpopup').classList.remove('hidden');
    document.querySelector('#feedbackpopup').classList.add('hidden');
    document.querySelector('#sadfeedback').classList.remove('hidden');
    document.querySelector('#happyfeedback').classList.add('hidden');

    document.getElementById('feedback_type').value = 'un_happy';
  }

  happyform() {
    document.getElementById('feedbackSubmit').disabled = false;
    document
      .getElementById('feedbackSubmit')
      .classList.remove('bg-doctor-yellow-500');
    document.getElementById('feedbackSubmit').classList.add('bg-doctor-yellow');

    document.querySelector('#feedbackformpopup').classList.remove('hidden');
    document.querySelector('#feedbackpopup').classList.add('hidden');
    document.querySelector('#sadfeedback').classList.add('hidden');
    document.querySelector('#happyfeedback').classList.remove('hidden');

    document.getElementById('feedback_type').value = 'happy';
  }

  enableFeedbackSubmit() {
    const message = document.getElementById('feedbackMessage').value;
    if (message.length > 10) {
      document.getElementById('feedbackSubmit').disabled = false;
      document
        .getElementById('feedbackSubmit')
        .classList.remove('bg-doctor-yellow-500');
      document
        .getElementById('feedbackSubmit')
        .classList.add('bg-doctor-yellow');
    } else {
      document.getElementById('feedbackSubmit').disabled = true;
      document
        .getElementById('feedbackSubmit')
        .classList.remove('bg-doctor-yellow');
      document
        .getElementById('feedbackSubmit')
        .classList.add('bg-doctor-yellow-500');
    }
  }

  submitfeedback() {
    document.querySelector('#feedbackformpopup form').classList.add('hidden');
    document.querySelector('#submitmessage').classList.remove('hidden');
    document.querySelectorAll('.feedback_option').forEach(function (element) {
      element.classList.add('hidden');
    });
  }
}
